import { AxiosError } from 'axios'
import { flow, makeAutoObservable, observable } from 'mobx'

import { openDocumentFromBuffer } from 'Shared/utils/file'

import { STORE_UI } from 'Core/constants/stores'
import { CustomGenerator } from 'Core/interfaces'

import { CompanyCategoryRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

import { CompanyCategoryTable } from './CompanyCategoryTable'

export class CompanyCategoryStore {
	table: CompanyCategoryTable
	@observable isOverviewDocumentDownloading: boolean = false

	constructor(public rootStore: RootStore) {
		this.table = new CompanyCategoryTable(rootStore)
		makeAutoObservable(this, {}, { autoBind: true })
	}

	@flow
	*downloadOverviewDocument(): CustomGenerator<ArrayBuffer> {
		this.isOverviewDocumentDownloading = true

		try {
			const document = yield CompanyCategoryRepo.downloadOverviewDocument()
			openDocumentFromBuffer(document)
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		} finally {
			this.isOverviewDocumentDownloading = false
		}
	}
}
